var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Carousel',{attrs:{"autoplay":"","scrollPerPage":"","loop":"","perPageCustom":[
    [0, 1],
    [1000, 1],
    [1024, 3] ],"autoplayHoverPause":"","paginationPadding":0}},_vm._l((_vm.slides),function(slide){return _c('Slide',{key:slide.name},[_c('img',{staticClass:"carosel_image",attrs:{"src":_vm.image(slide.photo)}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }